<template lang="html">
    <div v-if="improvement" class="container">
        <div class="row">
            <div class="col s12"><h5>Amélioration:  {{improvement.ref | ref}}</h5></div>
            <div class="col s12">
                <p class="btn-large disabled">Cloturée le {{improvement.updated_at | formatDate}}</p>
            </div>

            <div class="col s12"><label>Créée le </label>{{improvement.created_at | formatDate}} <label>par</label> {{improvement.user}}</div>
            <div class="col s4">
                <p>Objet: {{improvement.object}}</p>
            </div>
            <div class="col s4">
                <p>Fréquence: {{improvement.frequency}}</p>
            </div>
            <div class="col s4">
                <p>Etat visuel: {{improvement.visual_state}}</p>
            </div>

            <div class="col s12">
                <div class="row">
                        <div class="input-field col s12">
                            <p>Proposition:</p>
                            <textarea class="materialize-textarea" name="proposal" rows="34" v-model="improvement.proposal" disabled></textarea>
                        </div>
                        <div class="field col s6">
                            <p for="service">Service concerné:</p>
                            <input type="text" name="service" v-model="improvement.service" disabled>
                        </div>
                        <div class="field col s6">
                            <p for="situation">Situation:</p>
                            <input type="text" name="situation" v-model="improvement.situation" disabled>
                        </div>
                        <div class="input-field col s6">
                            <p>Conséquences positives:</p>
                            <textarea class="materialize-textarea" rows="34" v-model="improvement.pos_cons" disabled></textarea>
                        </div>
                        <div class="input-field col s6">
                            <p>Conséquences négatives:</p>
                            <textarea class="materialize-textarea" rows="34" v-model="improvement.neg_cons" disabled></textarea>
                        </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div v-for="item in improvement.medias">
                <div v-if="item" class="col s12 rotatable">
                        <img class="responsive-img " v-bind:src="item">
                    <div class="action">
                        <a v-bind:href="item" target="_blank" class="btn-large btn-floating waves-effect waves-light light-blue"><i class="material-icons">visibility</i></a>
                        <a @click.prevent="rotateLeft()" class="btn btn-floating waves-effect waves-light light-blue"><i class="material-icons">undo</i></a>
                        <a @click.prevent="flip()" class="btn btn-floating waves-effect waves-light light-blue"><i class="material-icons">autorenew</i></a>
                        <a @click.prevent="rotateRight()" class="btn btn-floating waves-effect waves-light light-blue"><i class="material-icons">redo</i></a>
                        <a @click.prevent="rotateReset()" class="btn-large btn-floating waves-effect waves-light light-blue"><i class="material-icons">sync_disabled</i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase/app'
import storage from 'firebase/storage'
import moment from 'moment'
import 'moment/locale/fr'

export default {
    name: 'ShowImprovement',
    data(){
        return{
            improvement: null,

        }
    },
    filters: {
        formatDate: function(value) {
            if (value) {
                return moment(value).locale('fr').format('LLL')
            }
        }
    },
    methods: {
        getImprovement(){
            //get improvement
            let ref = db.collection('improvements').where('ref', '==', this.$route.params.ref)
            ref.get().then(snapshot => {
                snapshot.forEach(doc => {
                    this.improvement = doc.data()
                    this.improvement.id = doc.id
                    })
            })
            .catch(err => {
                console.log(err)
            })
        },
        editImprovement(){
            //console.log(this.improvement)
            db.collection('improvements').doc(this.improvement.id).update({
                updated_at: Date.now(),
                service: this.improvement.service,
                visual_state: this.improvement.visual_state,
                situation: this.improvement.situation,
                proposal: this.improvement.proposal,
                pos_cons: this.improvement.pos_cons,
                neg_cons: this.improvement.neg_cons

            }).then (() => {
                this.$router.push({name: 'Admin'})
            }).catch(err => {
                console.log(err)
            })
        },
        setCancel(){
            db.collection('improvements').doc(this.improvement.id).update({
                state: 'annulée',
                updated_at: Date.now()
            }).then(() => {
                this.improvement.state = 'annulée',
                this.improvement.updated_at
            }).catch(err => {
                console.log(err)
            })
        },
        setOpen(){
            db.collection('improvements').doc(this.improvement.id).update({
                state: 'ouverte',
                updated_at: Date.now()
            }).then(() => {
                this.improvement.state = 'ouverte',
                this.improvement.updated_at = Date.now()
            }).catch(err => {
                console.log(err)
            })
        },
        setPending(){
            db.collection('improvements').doc(this.improvement.id).update({
                state: 'en cours',
                updated_at: Date.now()
            }).then(() => {
                this.improvement.state = 'en cours',
                this.improvement.updated_at = Date.now()
            }).catch(err => {
                console.log(err)
            })
        },
        setClose(){
            db.collection('improvements').doc(this.improvement.id).update({
                state: 'cloturée',
                updated_at: Date.now()
            }).then(() => {
                this.improvement.state = 'cloturée',
                this.improvement.updated_at = Date.now()
            }).catch(err => {
                console.log(err)
            })
        },
        rotateLeft(){
            $('.rotatable').removeClass('right-rotated')
            $('.rotatable').removeClass('flip')
            $('.rotatable').toggleClass('left-rotated')
        },
        rotateRight(){
            $('.rotatable').removeClass('left-rotated')
            $('.rotatable').removeClass('flip')
            $('.rotatable').toggleClass('right-rotated')
        },
        flip(){
            $('.rotatable').removeClass('left-rotated')
            $('.rotatable').removeClass('right-rotated')
            $('.rotatable').toggleClass('flip')
        },
        rotateReset(){
            $('.rotatable').removeClass('left-rotated')
            $('.rotatable').removeClass('right-rotated')
            $('.rotatable').removeClass('flip')
        }
    },
    created(){
        this.getImprovement()

    }
}
</script>

<style lang="css" scoped>
    img {
        width: 100%;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
    }

    .left-rotated{
        transform: rotate(-90deg);
        margin-top: 23% !important;
        margin-bottom: 23% !important;
    }

    .right-rotated{
        transform: rotate(90deg);
        margin-top: 23% !important;
        margin-bottom: 23% !important;
    }

    .flip{
        transform: rotate(180deg);
        /* margin-top: 23% !important;
        margin-bottom: 23% !important; */
    }

    .action{
        position: relative;
        top:-35px;
        left: -10px;
        text-align: left;
    }
</style>
